<template>
  <div class="sp-block">
    <div div class="sp-labels">
      <div class="sp-border">考核项</div>
      <div v-for="(x, i) in labels" :key="i" class="labels-block">
        <div class="sp-border lable-one xy-center">
          <div class="xy-center">
            {{ x[0] }}
          </div>
        </div>
        <div class="lable-one" v-show="x.length > 1">
          <div v-for="(y, j) in x.slice(1)" :key="j" class="sp-border">
            {{ y }}
          </div>
        </div>
      </div>
    </div>
    <div class="sp-score">
      <div class="sp-border">得分</div>
      <div v-for="(x, i) in scores" :key="i" class="sp-border">{{ x }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    scores: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style  lang="scss" scoped>
.sp-block {
  display: flex;
  text-align: center;
  border-top: 1px solid #e3e3e3;
  border-left: 1px solid #e3e3e3;
  line-height: 30px;
}
.sp-border {
  border-bottom: 1px solid #e3e3e3;
  border-right: 1px solid #e3e3e3;
}
.sp-score {
  width: 150px;
}
.sp-labels {
  flex: 1;
}

.labels-block {
  display: flex;
}
.lable-one {
  flex: 1;
}
.xy-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>